import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

interface UseUserProjectLinksParams {
  userId: number;
  projectId: number;
  queryParams?: {
    source?: 'admindashboard' | 'coachdashboard' | 'studentdashboard';
  };
}

const { useFind: useUserProjectLinks } = getCRUDHooks({
  entityName: 'userProjectLinks',
  find: ({ userId, projectId, queryParams }: UseUserProjectLinksParams) =>
    clientApi
      .getOCClient()
      .helpers.user.users.id(userId)
      .projects.id(projectId)
      .links.find(queryParams),
});

export {
  // eslint-disable-next-line import/prefer-default-export
  useUserProjectLinks,
};
